import PanelMenu from "./PanelMenu.js"
import ListItem from "./ListItem.js"
import Utils from "./Utils.js"

export default class SharePanel extends PanelMenu {

  constructor(props, context) {
    super(props, context)
    this.listOptions = [
       {label: "Facebook", id: "facebook", url: "www.facebook.html"},
       {label: "Twitter", id: "twitter", url: "www.twitter.com"},
       {label: "Email", id: "email", url: ""},
       {label: "Embed", id: "embed", url: ""}
     ]
  }

  static get contextTypes() {
    return super.contextTypes
  }

  clickHandler(object, index, event) {
    const media = this.player.media
    this.player.dispatch("share", {provider: object, link: media.link, embed: media.embed})
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.keyDown) {
      this.refs.element.childNodes[0].focus()
      this.state.keyDown = false
    }
  }

  render() {
    const OptionsList = this.listOptions.map((object,index) => {
      return <ListItem key={index}  className="amp-list-item" onClick={this.clickHandler.bind(this, object, index)}>
              <button className={`amp-icon amp-${object.id}`} tabIndex="-1"></button>
              <span>{object.label}</span>
             </ListItem>
    });

    return <div ref="element" className={`amp-share amp-panel ${this.className}`}>
            {OptionsList}
           </div>
  }
}
